import { useRouter } from 'next/dist/client/router';
import React from 'react';

import { useFullVariantByIdSsr } from '../../../api/hooks/useFullVariantByIdSsr.hook';
import { useVariantDetailPage } from '../../../api/hooks/useVariantDetailPage.hook';
import { TypographyVariantsEnum } from '../../../utils/_enums/typeography-variants.enum';
import { formatDateAndTime } from '../../../utils/_helper/time-helper';
import { useAppSelector } from '../../../utils/_hooks/hooks';
import { Typography } from '../typography/typography';
import styles from './generic-attribute-box.module.scss';
import { useGenres } from '../../../api/hooks/useGenres.hook';
import { useSubCategories } from '../../../api/hooks/useSubCategories.hook';
import { useCategories } from '../../../api/hooks/useCategories.hook';

interface GenericAttributeListProps {
  headline: string;
  attributes: {
    label: string
    value: string
  }[];
}

const GenericAttributeList = (props: GenericAttributeListProps): JSX.Element => {
  const { instance } = useAppSelector((state) => ({
    instance: state.productSlice.instance
  }));
  const data = useVariantDetailPage();
  const router = useRouter();
  const variant = useFullVariantByIdSsr();

  return (
    <div>
      <Typography variant={TypographyVariantsEnum.HEADING4_BOLD} className={styles['headline']}>
        {props.headline}
      </Typography>

      {
        data.resale && instance?.saleStartDate || data.resale && variant?.salesAttribute.saleFrom ? (
          <div className={styles['attribute-column']}>
            <Typography>{data.resale}</Typography>
            <Typography
              variant={TypographyVariantsEnum.MOBILENAVLINK}
            >
              {formatDateAndTime(!instance || !router.query.instanceId || !instance.saleStartDate
                ? (variant?.salesAttribute
                  .saleFrom as string)
                : instance.saleStartDate)}
            </Typography>
          </div>
        ) : null
      }

      {
        data?.salesEnd && variant?.salesAttribute?.saleTo ? (
          <div className={styles['attribute-column']}>
            <Typography>{data?.salesEnd}</Typography>
            <Typography
              variant={TypographyVariantsEnum.MOBILENAVLINK}
            >
              {formatDateAndTime(variant?.salesAttribute?.saleTo)}
            </Typography>
          </div>
        ) : null
      }

      {
        props.attributes.map(attr => (
          <div className={styles['attribute-column']} key={attr.label}>
            <Typography>{attr.label}</Typography>
            <Typography
              variant={TypographyVariantsEnum.MOBILENAVLINK}
            >
              {attr.value}
            </Typography>
          </div>
        ))
      }

      {
        data.series && variant?.product?.seriesName ? (
          <div className={styles['attribute-column']}>
            <Typography>{data.series}</Typography>
            <Typography
              variant={TypographyVariantsEnum.MOBILENAVLINK}
            >
              {variant?.product?.seriesName}
            </Typography>
          </div>
        ) : null
      }

      {
        data?.episode && variant.product.episode ? (
          <div className={styles['attribute-column']}>
            <Typography>{data?.episode}</Typography>
            <Typography
              variant={TypographyVariantsEnum.MOBILENAVLINK}
            >
              {variant.product.episode}
            </Typography>
          </div>
        ) : null
      }
    </div>
  );
};

export default GenericAttributeList;
